// 奶水乐园 - FAQ 模拟数据
export const faqItems = [
  {
    question: "奶水不足的主要表现有哪些？",
    answer: "奶水不足的常见表现包括：宝宝吃完奶后仍然哭闹、体重增长缓慢、每天湿尿布少于6片、哺乳后乳房仍然感觉胀满但宝宝似乎没吃饱。但请注意，宝宝的哭闹不一定代表奶水不足，建议结合多种指标综合判断。如果担心，可以咨询专业哺乳顾问进行评估。",
  },
  {
    question: "产后多久奶水才会充足？",
    answer: "产后奶水通常在产后2-5天开始大量分泌（俗称'下奶'或'涨奶'）。初乳在孕期就已开始产生，量虽少但营养极其丰富。每个妈妈的情况不同，有些妈妈下奶较晚也属于正常现象。关键是产后尽早开始哺乳、保持频繁喂养，这有助于刺激乳汁分泌。",
  },
  {
    question: "催奶食物真的有效吗？",
    answer: "部分传统催奶食物确实有一定科学依据。例如：鲫鱼富含优质蛋白和Omega-3脂肪酸，有助于乳汁分泌；猪蹄含有丰富的胶原蛋白和钙质；木瓜中的酵素可以促进蛋白质吸收；麦芽水能补充B族维生素。但需要注意，催奶食物的效果因人而异，最重要的还是保持充足的休息、大量饮水和频繁哺乳。",
  },
  {
    question: "母乳应该如何正确储存？",
    answer: "新鲜母乳在室温（25℃以下）可存放4小时；冷藏室（0-4℃）可存放3-5天；冷冻室（-18℃以下）可存放3-6个月。储存时请使用专用的母乳储存袋或玻璃容器，标注日期。解冻时应在冷藏室自然解冻或用温水加热，切勿使用微波炉加热，以免破坏营养成分并产生热点烫伤宝宝。",
  },
  {
    question: "追奶需要多长时间才能看到效果？",
    answer: "追奶效果因人而异，通常情况下坚持正确的追奶方法3-7天就能看到明显改善。关键在于：增加哺乳频率（每2-3小时一次）、确保正确衔乳姿势、两侧乳房交替喂养、多喝水（每天至少2000ml）、保证充足睡眠。如果两周后仍无改善，建议咨询专业的哺乳顾问或医生。",
  },
  {
    question: "哺乳期可以喝咖啡吗？",
    answer: "哺乳期可以适量饮用咖啡，但需要控制摄入量。建议每天咖啡因摄入不超过200-300mg（约1-2小杯咖啡）。咖啡因会通过母乳传递给宝宝，过量可能导致宝宝烦躁、睡眠不佳。最好在哺乳后饮用，这样可以拉长与下次哺乳的时间间隔，减少对宝宝的影响。",
  },
  {
    question: "外出时如何保持母乳喂养？",
    answer: "外出哺乳可以做好以下准备：1）穿着便于哺乳的衣服（如哺乳专用衣或前开扣上衣）；2）携带哺乳巾或披肩增加隐私；3）提前了解目的地附近的母婴室位置；4）随身携带吸奶器和储奶装备，以备不时之需；5）保持自信心态——母乳喂养是妈妈和宝宝最自然的事情，无需感到尴尬。",
  },
  {
    question: "宝宝突然拒绝吃母乳怎么办？",
    answer: "宝宝突然拒绝哺乳（乳头混淆或哺乳罢工）的原因可能包括：出牙不适、鼻塞导致呼吸困难、奶水流量变化、环境干扰、妈妈饮食改变导致奶水味道变化等。建议在安静、光线柔和的环境中尝试哺乳，尝试不同姿势，先挤出少量奶水涂抹在乳头上引发宝宝的吸吮反射。保持耐心和淡定，不要强迫宝宝。",
  },
];